const e = "Aktion abgelaufen. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.", s = { 400: "Diese E-Mail-Adresse ist auf $t(_company) nicht registriert. Bitte stellen Sie sicher, dass sie korrekt ist, oder melden Sie sich unten an.", 404: "$t(responses.login.400)", 500: "$t(responses.default)" }, t = { 400: "$t(responses.default)", 500: "$t(responses.default)" }, n = { 2033: "Sitzung erfolgreich erstellt.", 2064: "Sitzung erfolgreich aktualisiert." }, i = { 200: "Ihre erste Sitzung wurde erfolgreich erstellt.", 201: "$t(responses.dashboardSession.200)" }, r = { 2084: "Die Anfrage auf Zugang zur Sitzung war bereits im genehmigten Zustand", 2088: "Sie haben bereits Zugang zu dieser Sitzung beantragt.", email: { 200: "Personen hinzugefügt" }, domain: { 200: "Gruppe hinzugefügt" } }, u = { 200: "Großartig! Wir halten Sie auf dem Laufenden." }, a = { 404: "$t(responses.default)", 405: "Der Verifizierungscode ist falsch. Bitte überprüfen Sie noch einmal.", 500: "$t(responses.default)" }, o = { 500: "Entschuldigung, etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.", avatar: { 400: "Fehler beim Speichern des Avatars. Bitte versuchen Sie es erneut." } }, g = {
  default: "Entschuldigung, etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  timeout: e,
  login: s,
  register: t,
  session: n,
  dashboardSession: i,
  sessionAccess: r,
  subscribe: u,
  verify: a,
  user: o
};
export {
  i as dashboardSession,
  g as default,
  s as login,
  t as register,
  n as session,
  r as sessionAccess,
  u as subscribe,
  e as timeout,
  o as user,
  a as verify
};
